module.exports = __webpack_public_path__ + "img/142.53b6e4c0.png";